import { Box, Stack, Typography } from '@mui/material';
import React from 'react';

interface MetadataContainerProps {
	title: string;
	children: React.ReactNode;
}

const MetadataContainer: React.FC<MetadataContainerProps> = ({ title, children }) => {
	return (
		<Box padding={2}>
			<Stack spacing={2} padding={2} position={'relative'} borderRadius={2} border={'solid'}>
				<Box
					component={'span'}
					top={-16}
					sx={{
						position: 'absolute',
						backgroundColor: 'background.default',
						paddingX: 1,
					}}
				>
					<Typography variant="h5" component={'h2'}>
						{title}
					</Typography>
				</Box>
				{children}
			</Stack>
		</Box>
	);
};

export default MetadataContainer;
